import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../services/dashboard.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

@Component({
  selector: 'app-tests',
  templateUrl: './tests.component.html',
  styleUrls: ['./tests.component.scss']
})
export class TestsComponent implements OnInit {

  isLoading = true;

  message;

  studentId;

  testTabsData = [];
  activeTab;

  apiResponse;

  testNameForChart;
  testDataForChart = [];


  constructor(private dashboardService: DashboardService, private activatedRoute: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    this.dashboardService.getProfileTabFlag().subscribe(data => {
      if (data == 'tests') {
        console.log('get test Results call');
        this.getTestResults();
      }
    });

  }

  getTestResults() {
    this.isLoading = true;

    this.activatedRoute.paramMap.subscribe((params: ParamMap) => this.studentId = (params.get('student_id')));

    this.dashboardService.getStudentTestResults({ student_id: this.studentId }).subscribe(response => {
      this.isLoading = false;

      console.log('test--', response);
      if (response.status == false && response.statusCode == 200) {
        this.message = response.message;
      }
      else if (response.status == true && response.statusCode == 200) {
        if (response.data.os_report.length == 0) {
          this.message = 'Assessments not started yet.';
        }
        else {
          this.apiResponse = response.data;

          this.testTabsData = [
            { name: 'Orientation <br> Style', imgUrl: 'http://mindlerdashboard.imgix.net/test-o.png', value: 'os', enabled: (this.apiResponse.os_report.length > 0) ? true : false },
            { name: 'Interest', imgUrl: 'http://mindlerdashboard.imgix.net/test-i.png', value: 'interest', enabled: (this.apiResponse.get_i_report.length > 0) ? true : false },
            { name: 'Personality', imgUrl: 'http://mindlerdashboard.imgix.net/test-p.png', value: 'personality', enabled: (this.apiResponse.get_p_report.length > 0) ? true : false },
            { name: 'Aptitude', imgUrl: 'http://mindlerdashboard.imgix.net/test-a.png', value: 'aptitude', enabled: (this.apiResponse.get_a_report.length > 0) ? true : false }
          ];
          // EQ (not for stream user)
          if (this.apiResponse.basicinfo.package_id != 1) {
            this.testTabsData.push({ name: 'Emotional <br> Quotient', imgUrl: 'http://mindlerdashboard.imgix.net/test-eq.png', value: 'eq', enabled: (this.apiResponse.get_e_report.length > 0) ? true : false });
          }

          this.displayChartForTestResult('os');
        }
      }
    });
  }

  displayChartForTestResult(testCategory) {

    if (testCategory === 'os') {
      this.activeTab = 'os';
      this.testNameForChart = 'Orientation Style';
      this.testDataForChart = this.apiResponse.os_report;
    }
    else if (testCategory === 'interest') {
      this.activeTab = 'interest';
      this.testNameForChart = 'Interest';
      this.testDataForChart = this.apiResponse.get_i_report;
    }
    else if (testCategory === 'personality') {
      this.activeTab = 'personality';
      this.testNameForChart = 'Personality';
      this.testDataForChart = this.apiResponse.get_p_report;
    }
    else if (testCategory === 'aptitude') {
      this.activeTab = 'aptitude';
      this.testNameForChart = 'Aptitude';
      this.testDataForChart = this.apiResponse.get_a_report;
    }
    else if (testCategory === 'eq') {
      this.activeTab = 'eq';
      this.testNameForChart = 'Emotional Quotient';
      this.testDataForChart = this.apiResponse.get_e_report;
    }

  }

}
